import { FC } from "react";

import { ReactComponent as JudiBrandLogo } from "../../assets/judi-brand-logo.svg";

import { ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
}

/** The Judi avatar shown beside assistant turns and status indicators. */
export const BotAvatar: FC<Props> = ({ styles }) => (
  <div className={styles.BotAvatar}>
    <JudiBrandLogo className={styles.BotAvatarImage} aria-hidden="true" />
  </div>
);
